import { render, staticRenderFns } from "./superadmin-options-page.vue?vue&type=template&id=aed9b68a&"
import script from "./superadmin-options-page.vue?vue&type=script&lang=ts&"
export * from "./superadmin-options-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports